import { usePageMeta } from '@/hooks/usePageMeta';
import Breadcrumb from '@/components/feature/Breadcrumb';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/faqs';

export default function Faq() {
  usePageMeta({
    title: '常见问题 FAQ - 韩漫漫画网',
    description:
      '韩漫漫画网常见问题：题材分类有哪些、如何快速找到想看的韩漫、更新频率、阅读方式与访问体验等常见疑问，这里都有答案。',
    keywords: '韩漫漫画网,常见问题,韩漫题材分类,韩漫更新,FAQ',
    canonical: 'https://lovecomix.github.io/faq',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    },
  });

  return (
    <div className="min-h-screen bg-background-50 pt-24">
      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-12">
          <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '常见问题' }]} />
          <div className="mt-6 max-w-3xl">
            <h1 className="font-heading text-3xl text-foreground-950 md:text-4xl">常见问题</h1>
            <p className="mt-3 leading-relaxed text-foreground-600">
              关于题材分类、更新与阅读的常见疑问都整理在这里。如果还有没解答到的问题，欢迎随时反馈。
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 py-12 md:px-6 md:py-16">
        <FaqAccordion items={faqs} />

        <div className="mt-10 rounded-2xl bg-background-100 p-6 text-center ring-1 ring-background-200/70">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-xl text-secondary-700 mx-auto">
            <i className="ri-question-line" />
          </span>
          <h2 className="mt-4 text-lg font-semibold text-foreground-950">还有别的问题？</h2>
          <p className="mx-auto mt-2 max-w-md text-sm text-foreground-600">
            想找特定题材的韩漫却还没找到？欢迎到对应分类页筛选，或通过站内反馈渠道告诉我们。
          </p>
          <a
            href="mailto:hello@hanman.example.com"
            className="mt-5 inline-flex items-center gap-1 rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-mail-line" /> 联系我们
          </a>
        </div>
      </section>
    </div>
  );
}